// This is the entry point for the home component
import React, { FC, useContext } from 'react';
import { connect } from 'react-redux';
import UserDetailsContext from 'Context/userDetailsContext';
import { USER_LOGOUT } from 'HOC/Apollo/constants/queries';
import gql from 'graphql-tag';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQuery } from '@apollo/react-hooks';
import { withApollo } from 'react-apollo';
import { ProductAnalyticsContext } from 'Context/ProductAnalytics';
import { AnnouncementCookieTypes } from 'Types/announcements';
import { deleteCookie } from 'Utils/cookies';
import { getRedirectURL } from '../../utils';

interface Props {
  client: any;
}

const Logout: FC<Props> = (props: Props) => {
  const userDetails = useContext(UserDetailsContext);
  const {
    actions: { track },
  } = useContext(ProductAnalyticsContext);

  const { client } = props;
  useQuery(gql(USER_LOGOUT), {
    variables: {
      userID: userDetails.userId,
    },
    onCompleted: () => {
      // Combined Analytics
      track('logged_out', { send_immediately: true }, () => {
        window.sessionStorage.clear();
        client.cache.reset();
        window.location.href = getRedirectURL();
      });
      window.sessionStorage.clear();
      client.cache.reset();
      deleteCookie(AnnouncementCookieTypes.SESSION);
      window.location.href = getRedirectURL();
    },
  });

  return (
    <>
      <h1>Logging out...</h1>
    </>
  );
};

export default connect(null)(withApollo(Logout));
try {
    // @ts-ignore
    Logout.displayName = "Logout";
    // @ts-ignore
    Logout.__docgenInfo = { "description": "", "displayName": "Logout", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/pages/Logout/Logout.tsx#Logout"] = { docgenInfo: Logout.__docgenInfo, name: "Logout", path: "src/pages/Logout/Logout.tsx#Logout" };
}
catch (__react_docgen_typescript_loader_error) { }